// extracted by mini-css-extract-plugin
export default {"menuIcon":"side-menu_component_menuIcon__zgpk8"};